import React from 'react';
import {useIntl} from 'react-intl';
import {LiteEmptyPage} from './LiteEmptyPage';

export const LiteModelInfo = () => {
  const intl = useIntl();
  return (
    <LiteEmptyPage>
      <h5>{intl.formatMessage({id: 'studioLite.models.header'})}</h5>
      <p>{intl.formatMessage({id: 'studioLite.models.1'})}</p>
      <p>
        {intl.formatMessage(
          {id: 'studioLite.models.2'},
          {
            learnLink: (
              <a
                href="https://www.blaize.com/products/ai-studio/"
                target="_blank"
                rel="noreferrer"
              >
                here
              </a>
            ),
          }
        )}
      </p>
    </LiteEmptyPage>
  );
};
